import { render, staticRenderFns } from "./clientheadercontent.vue?vue&type=template&id=474e26ac"
import script from "./clientheadercontent.vue?vue&type=script&lang=js"
export * from "./clientheadercontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports